/**
 * @module store/stats/actions
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetStats } from '@/api';
import * as types from '@/store/mutation-types';


/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getStats = async ({ commit, rootGetters }) => {
  try {
    commit(types.GET_STATS_ASYNC.PENDING);
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const stats = await apiGetStats(userSession.accessToken.jwtToken);
      commit(types.GET_STATS_ASYNC.SUCCESS, stats);
    } else {
      throw new Error('Неавторизованный пользователь не может плучать информацию о точках.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_STATS_ASYNC.FAILURE);
  }
};

export default {
  getStats,
};
